import React from 'react';
import PropTypes from 'prop-types';
import SrText from 'client/components/SrText';
import './ImageGallery.less';

const ImageGallery = ({ images = [] }) => {
  if (!images.length) {
    return (
      <div styleName="container">
        <SrText font="whitney-sc" weight="bold" size="md" display="block" marginBottom={8}>
          Screenshots
          <SrText font="whitney" size="sm" display="block">
            No screenshots available at the moment
          </SrText>
        </SrText>
      </div>
    );
  }

  return (
    <div styleName="container">
      <SrText font="whitney-sc" weight="bold" size="md" display="block" marginBottom={8}>
        Screenshots
        <SrText font="whitney" size="sm" display="block" color="#666">
          Note: For security reasons these screenshots URLs are temporary and will expire in 5
          minutes. Do not share or store these URLs. All screenshots will remain accessible in the
          order details.
        </SrText>
      </SrText>
      <div styleName="scrollContainer">
        {images.map((imageUrl, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} styleName="imageWrapper">
            <a href={imageUrl} target="_blank" rel="noopener noreferrer" styleName="imageLink">
              <img src={imageUrl} alt="Temporary screenshot" styleName="image" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
};

export default ImageGallery;
